<template>
    <table class="info-table">
        <tbody>
        <tr>
            <th>展会名称：</th>
            <td>{{configs['from_meeting_name']}}</td>
        </tr>
        <tr>
            <th>展会地址：</th>
            <td>{{configs['from_address']}}</td>
        </tr>
        <tr>
            <th>展会日期：</th>
            <td>{{configs['from_data']}}</td>
        </tr>
        <tr>
            <th>联系人姓名：</th>
            <td>{{configs['from_name']}}</td>
        </tr>
        <tr>
            <th>联系人电话：</th>
            <td>{{configs['from_tel']}}</td>
        </tr>
        <tr>
            <th>是否自己搭建：</th>
            <td>{{configs['from_build']}}</td>
        </tr>
        <tr>
            <th>展会预计参展人数：</th>
            <td>{{configs['from_people']}}</td>
        </tr>
        <tr>
            <th>展台尺寸：</th>
            <td>{{configs['from_size']}}</td>
        </tr>
        <tr>
            <th>展台预算：</th>
            <td>{{configs['from_budget']}}</td>
        </tr>
        <tr>
            <th>设计师：</th>
            <td>{{get_job(configs['from_deposit'])}}</td>
        </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "DemandTable",
    components: {},
    props: ['configstr'],
    data:function() {
        return {
            configs: {},
            jobs:{"11":"优秀设计师","12":"资深设计师","13":"设计总监","14":"顶尖设计师"},
        }
    },
    computed:{
    },
    methods:{
        get_job(index){
            return this.jobs[index];
        },
        get_demandtable(){
            if(this.configstr){
                this.configs=Object.assign({},this.configs,JSON.parse(this.configstr));
            }
            console.log("this.configs",this.configs);
        }
    },

    mounted() {
        this.get_demandtable();
    }
}
</script>

<style lang="scss" scoped>
    .info-table {
        color: #757575;
        tr {
            height: 30px;
            line-height: 30px;
        }
        .info-div {
         height: 30px;
            line-height: 30px;
        }
    }
</style>